// Geração de código de barras CODE 39 (Full ASCII / "Extended") como SVG e
// impressão em uma folha A4 no formato paisagem (1 código por folha).
//
// Não depende de lib externa: o SVG é montado à mão a partir das tabelas do
// Code 39. Para valores no charset padrão (A-Z, 0-9, ' ', '-', '.') o resultado
// é idêntico ao Code 39 padrão; demais caracteres usam as sequências de shift
// do Full ASCII ($, %, /, +).

// Padrão de cada caractere base: 9 elementos (barra/espaço alternados, começando
// e terminando em barra). 'w' = largo, 'n' = estreito. 3 elementos largos cada.
const CODE39 = {
  '0': 'nnnwwnwnn', '1': 'wnnwnnnnw', '2': 'nnwwnnnnw', '3': 'wnwwnnnnn',
  '4': 'nnnwwnnnw', '5': 'wnnwwnnnn', '6': 'nnwwwnnnn', '7': 'nnnwnnwnw',
  '8': 'wnnwnnwnn', '9': 'nnwwnnwnn',
  'A': 'wnnnnwnnw', 'B': 'nnwnnwnnw', 'C': 'wnwnnwnnn', 'D': 'nnnnwwnnw',
  'E': 'wnnnwwnnn', 'F': 'nnwnwwnnn', 'G': 'nnnnnwwnw', 'H': 'wnnnnwwnn',
  'I': 'nnwnnwwnn', 'J': 'nnnnwwwnn', 'K': 'wnnnnnnww', 'L': 'nnwnnnnww',
  'M': 'wnwnnnnwn', 'N': 'nnnnwnnww', 'O': 'wnnnwnnwn', 'P': 'nnwnwnnwn',
  'Q': 'nnnnnnwww', 'R': 'wnnnnnwwn', 'S': 'nnwnnnwwn', 'T': 'nnnnwnwwn',
  'U': 'wwnnnnnnw', 'V': 'nwwnnnnnw', 'W': 'wwwnnnnnn', 'X': 'nwnnwnnnw',
  'Y': 'wwnnwnnnn', 'Z': 'nwwnwnnnn',
  '-': 'nwnnnnwnw', '.': 'wwnnnnwnn', ' ': 'nwwnnnwnn', '$': 'nwnwnwnnn',
  '/': 'nwnwnnnwn', '+': 'nwnnnwnwn', '%': 'nnnwnwnwn', '*': 'nwnnwnwnn',
}

// Tabela Full ASCII: código ASCII (0-127) → sequência de caracteres base.
const FULL_ASCII = [
  '%U', '$A', '$B', '$C', '$D', '$E', '$F', '$G', '$H', '$I', '$J', '$K', '$L', '$M', '$N', '$O',
  '$P', '$Q', '$R', '$S', '$T', '$U', '$V', '$W', '$X', '$Y', '$Z', '%A', '%B', '%C', '%D', '%E',
  ' ', '/A', '/B', '/C', '/D', '/E', '/F', '/G', '/H', '/I', '/J', '/K', '/L', '-', '.', '/O',
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '/Z', '%F', '%G', '%H', '%I', '%J',
  '%V', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
  'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '%K', '%L', '%M', '%N', '%O',
  '%W', '+A', '+B', '+C', '+D', '+E', '+F', '+G', '+H', '+I', '+J', '+K', '+L', '+M', '+N', '+O',
  '+P', '+Q', '+R', '+S', '+T', '+U', '+V', '+W', '+X', '+Y', '+Z', '%P', '%Q', '%R', '%S', '%T',
]

function encode39(value) {
  let s = '*' // start
  for (const ch of String(value)) {
    const code = ch.charCodeAt(0)
    if (code > 127) continue // ignora fora do ASCII
    s += FULL_ASCII[code]
  }
  s += '*' // stop
  return s
}

function buildCode39Svg(value, { narrow = 3, ratio = 2.6, height = 160 } = {}) {
  const wide = Math.round(narrow * ratio)
  const encoded = encode39(value)
  const rects = []
  let x = 0
  for (let i = 0; i < encoded.length; i++) {
    const pattern = CODE39[encoded[i]]
    if (!pattern) continue
    for (let j = 0; j < 9; j++) {
      const w = pattern[j] === 'w' ? wide : narrow
      if (j % 2 === 0) rects.push(`<rect x="${x}" y="0" width="${w}" height="${height}"/>`) // barras nas posições pares
      x += w
    }
    x += narrow // espaço estreito entre caracteres
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" class="bc" viewBox="0 0 ${x} ${height}" preserveAspectRatio="xMidYMid meet" fill="#000">${rects.join('')}</svg>`
}

function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function barcodeDocHTML(value) {
  const svg = buildCode39Svg(value)
  const label = `*${esc(value)}*`
  return `<!doctype html>
<html lang="pt-BR">
<head>
<meta charset="utf-8" />
<title>Box ${esc(value)}</title>
<style>
  @page { size: A4 landscape; margin: 8mm; }
  * { box-sizing: border-box; }
  html, body { height: 100%; margin: 0; }
  body { display: flex; align-items: center; justify-content: center;
         font-family: Arial, Helvetica, sans-serif; background: #fff; }
  .wrap { text-align: center; width: 100%; }
  svg.bc { height: 45mm; width: auto; max-width: 260mm; display: block; margin: 0 auto; }
  .label { margin-top: 9mm; font-family: 'Courier New', monospace;
           font-size: 26pt; font-weight: 700; letter-spacing: 6px; color: #000; }
  @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
</style>
</head>
<body onload="window.focus(); window.print();">
  <div class="wrap">
    ${svg}
    <div class="label">${label}</div>
  </div>
  <script>window.onafterprint = function () { window.close(); };</script>
</body>
</html>`
}

/**
 * Abre uma janela A4 paisagem com o código de barras Code 39 do box e imprime.
 * Retorna { ok, error } — 'empty' (sem valor) ou 'popup_blocked'.
 */
export function printBoxBarcode(value) {
  if (!value) return { ok: false, error: 'empty' }
  const win = window.open('', '_blank', 'width=1000,height=720')
  if (!win) return { ok: false, error: 'popup_blocked' }
  win.document.open()
  win.document.write(barcodeDocHTML(value))
  win.document.close()
  return { ok: true }
}
